<template>
  <div class="carousel">
    <div class="carousel-inner" :style="{ transform: `translateX(-${currentIndex * itemWidth}px)` }">
      <div class="carousel-item" v-for="(item, index) in repeatedItems" :key="index">
        <div class="img-box" v-for="(img, imgIndex) in item.imgs" :key="imgIndex">
          <img :src="img.src" />
          <div class="item-desc-row">
            {{ img.desc }}
          </div>

        </div>


      </div>
    </div>
    <div class="carousel-indicators">
      <div class="carousel-indicator" v-for="(item, index) in [0, 1]" :key="index"
        :class="{ 'active': index === currentIndex }" @click="currentIndex = index"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          imgs: [
            {
              src: "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/problem_fan1.png",
              desc: "传统人工巡检"
            },
            {
              src: "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/problem_fan2.png",
              desc: "传统无人机巡检"
            },
          ],
        },
        {
          imgs: [
            {
              src: "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/problem_fan3.png",
              desc: "物联网大数据监控"
            }
          ],
        },
      ],
      currentIndex: 0,
      itemWidth: 0,
      autoScrollInterval: null,
    };
  },
  computed: {
    repeatedItems() {
      return [...this.items, ...this.items];
    },
  },
  mounted() {
    this.itemWidth = this.$el.querySelector(".carousel-item").offsetWidth;
    this.startAutoScroll();
  },
  methods: {
    startAutoScroll() {
      this.autoScrollInterval = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % 2;
      }, 3000);
    },
    stopAutoScroll() {
      clearInterval(this.autoScrollInterval);
    },
  },
  beforeUnmount() {
    this.stopAutoScroll();
  },
};
</script>

<style lang="stylus" scoped>
  .carousel {
    width: 100%;
    overflow: hidden;
    margin: 34px 0 24px;
    position:relative;
    padding-bottom:30px;
  }
  
  .carousel-inner {
    display: flex;
    transition: transform 0.5s ease-in-out;
    width: calc(100% * 2);
    overflow:hidden;
  }
  
  .carousel-item {
    flex: 0 0 50%;
    display: flex;
    max-width: 50%;
    justify-content: center;
    align-items: center;
  
    .img-box {
      width: calc(50% - 20px);
      img {
        width:100%;
      }
    }
  
    .img-box:nth-child(1) {
      margin-right: 20px;
    }
    .item-desc-row {
        text-align:center;
        margin-top:4px;
        color:#222;
        font-weight:bold;
        font-size:14px;
        span {
            color:#E30000;
        }
    }
  }
  
  .carousel-indicators {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    position:absolute;
    left:50%;
    transform: translateX(-50%);
    bottom:5px;
  
    .carousel-indicator {
      width: 10px;
      height: 3px;
      border-radius: 2px;
      background-color: #E0E0E0;
      margin: 0 4px;
      cursor: pointer;
  
      &.active {
        background-color: #2372E9;
        width:14px;
      }
    }
  }
  </style>